module.exports = __webpack_public_path__ + "img/linkedin.9f827931.png";